<template>
    <div id="app">
        <component :is="layout || 'section'">
            <router-view></router-view>
        </component>
    </div>
</template>

<script>
    export default {
        name: 'app_main',
        computed: {
            layout() {
                return this.$route.meta.layout
            }
        },
        data() {
            return {
                
            }
        }
    }
</script>

<style lang="scss">
    #app {
        font-family: OpenSans-Regular;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        width: 100vw !important;
        text-align: left;
        color: #000000;
    }
</style>
